import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, Menu, X, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import logo from "../assets/logo.png";

const navBase = "text-sm font-medium tracking-wide text-amber-950/90 hover:text-amber-700 transition";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { user, logout } = useAuth();
  const { cart } = useCart();
  const navigate = useNavigate();

  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-xl border-b border-amber-200 shadow-[0_6px_24px_rgba(120,53,15,0.08)]">
      <div className="h-0.5 bg-gradient-to-r from-transparent via-amber-500/70 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
	          <Link to="/" className="flex items-center gap-2.5">
              <div className="h-12 w-12 overflow-hidden flex items-center justify-center">
                <img
                  src={logo}
                  alt="Gwal Spices logo"
                  className="h-full w-full object-contain"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.parentElement.textContent = "GS";
                  }}
                />
              </div>
	            <span className="relative text-2xl font-extrabold tracking-tight text-amber-900">
	              gwalspices
	              <span className="absolute -top-1 -right-4 text-[10px] font-bold text-amber-700">TM</span>
	            </span>
	          </Link>

          <div className="hidden md:flex items-center space-x-7">
            <Link to="/" className={navBase}>Home</Link>
            <Link to="/shop" className={navBase}>Products</Link>
            <Link to="/about" className={navBase}>About</Link>
            <Link to="/contact" className={navBase}>Contact</Link>
            {user?.role === "admin" && (
              <Link to="/admin" className="text-sm font-semibold text-orange-700 hover:text-orange-800 transition">
                Admin
              </Link>
            )}
          </div>

          <div className="flex items-center space-x-3">
            <Link to="/cart" className="relative p-2 rounded-lg hover:bg-amber-50 transition">
              <ShoppingCart className="h-5 w-5 text-amber-900" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-orange-600 text-white text-[10px] rounded-full h-5 min-w-5 px-1 flex items-center justify-center font-bold">
                  {cartCount}
                </span>
              )}
            </Link>

            {user ? (
              <div className="hidden md:flex items-center space-x-4">
                <Link to="/my-orders" className={navBase}>Orders</Link>
                <Link to="/profile" className={navBase}>Profile</Link>
                <button
                  onClick={handleLogout}
                  className="p-2 rounded-lg text-amber-900 hover:text-red-600 hover:bg-red-50 transition"
                >
                  <LogOut className="h-5 w-5" />
                </button>
              </div>
            ) : (
              <Link to="/login" className="hidden md:block">
                <button className="bg-amber-700 hover:bg-amber-800 text-white px-5 py-2 rounded-lg text-sm font-semibold tracking-wide transition">
                  LOGIN
                </button>
              </Link>
            )}

            <button
              className="md:hidden p-2 rounded-lg text-amber-900 hover:bg-amber-50"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-amber-200 bg-white/95">
            <div className="flex flex-col space-y-4">
              <Link to="/" className={navBase} onClick={() => setMobileMenuOpen(false)}>Home</Link>
              <Link to="/shop" className={navBase} onClick={() => setMobileMenuOpen(false)}>Products</Link>
              <Link to="/about" className={navBase} onClick={() => setMobileMenuOpen(false)}>About</Link>
              <Link to="/contact" className={navBase} onClick={() => setMobileMenuOpen(false)}>Contact</Link>

              {user ? (
                <>
                  <Link to="/my-orders" className={navBase} onClick={() => setMobileMenuOpen(false)}>Orders</Link>
                  <Link to="/profile" className={navBase} onClick={() => setMobileMenuOpen(false)}>Profile</Link>
                  {user.role === "admin" && (
                    <Link to="/admin" className={navBase} onClick={() => setMobileMenuOpen(false)}>Admin</Link>
                  )}
                  <button
                    onClick={() => {
                      handleLogout();
                      setMobileMenuOpen(false);
                    }}
                    className="text-left text-red-600 font-medium"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <Link to="/login" onClick={() => setMobileMenuOpen(false)}>
                  <button className="bg-amber-700 hover:bg-amber-800 text-white px-6 py-2 rounded-lg w-full font-semibold">
                    LOGIN
                  </button>
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;




